import { Link } from "react-router-dom";
import { Phone, Mail, MapPin } from "lucide-react";
import { CONTACT, NAV_LINKS, CATEGORIES } from "../data/site";

export const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-[#041237] border-t border-white/10" data-testid="site-footer">
      <div className="mx-auto max-w-[1440px] px-4 sm:px-8 lg:px-16 py-16 lg:py-20">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <div className="flex items-center gap-4">
              <img src="/logo-full.png" alt="MAXIMUS TREADS logo" className="h-20 w-20 object-contain" data-testid="footer-logo" />
              <span className="font-mono text-[9px] tracking-[0.45em] text-slate-400 border-l border-white/15 pl-4 pt-1">TREADS</span>
            </div>
            <p className="mt-5 text-sm text-slate-400 leading-relaxed">
              {CONTACT.tagline}. Manufactured in the State of Tripura for customers who measure value in kilometres.
            </p>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500 leading-relaxed">
              {CONTACT.note}
            </p>
          </div>

          <div>
            <h3 className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber">Explore</h3>
            <ul className="mt-5 space-y-3">
              {NAV_LINKS.map((l) => (
                <li key={l.to}>
                  <Link to={l.to} className="text-sm text-slate-300 hover:text-white transition-colors" data-testid={`footer-link-${l.label.toLowerCase()}`}>
                    {l.label}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/privacy" className="text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-link-privacy">Privacy Policy</Link>
              </li>
              <li>
                <Link to="/terms" className="text-sm text-slate-300 hover:text-white transition-colors" data-testid="footer-link-terms">Terms of Use</Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber">Product Lines</h3>
            <ul className="mt-5 space-y-3">
              {CATEGORIES.map((c) => (
                <li key={c.id}>
                  <Link to={`/products?category=${c.id}`} className="text-sm text-slate-300 hover:text-white transition-colors" data-testid={`footer-link-${c.id}`}>
                    {c.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-mono text-[10px] uppercase tracking-[0.3em] text-amber">Contact</h3>
            <ul className="mt-5 space-y-4 text-sm text-slate-300">
              <li className="flex gap-3">
                <MapPin size={16} className="text-amber shrink-0 mt-0.5" />
                <span>{CONTACT.addressLines[0]},<br />{CONTACT.addressLines[1]}</span>
              </li>
              {CONTACT.phones.map((p) => (
                <li key={p} className="flex gap-3">
                  <Phone size={16} className="text-amber shrink-0" />
                  <a href={`tel:+91${p}`} className="hover:text-white transition-colors" data-testid={`footer-phone-${p}`}>+91 {p}</a>
                </li>
              ))}
              <li className="flex gap-3">
                <Mail size={16} className="text-amber shrink-0" />
                <a href={`mailto:${CONTACT.email}`} className="hover:text-white transition-colors break-all" data-testid="footer-email">{CONTACT.email}</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4 border-t border-white/10 pt-6">
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
            © {year} {CONTACT.company}. All rights reserved.
          </p>
          <p className="font-mono text-[10px] uppercase tracking-[0.2em] text-slate-600">
            Enquiries only — no online payment
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
